<section class="bg-white py-4">
  <p class="text-center text-[42px] text-[#282c3f]">
    Over <strong>6 Million</strong> Happy Customers
  </p>
</section>
